module.exports = __webpack_public_path__ + "img/laf.58b75b49.svg";